import { MatchingProvider } from '@context/Matching';
import MatchingView from './MatchingView';
import { useLocation } from 'react-router-dom';

interface MatchingLocation {
  state: {
    treatmentId: string;
  };
}

const Matching = () => {
  const { state } = useLocation() as MatchingLocation;

  return (
    <MatchingProvider treatmentId={state.treatmentId}>
      <MatchingView />
    </MatchingProvider>
  );
};

export default Matching;
